
const config = {
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: `${window.location.origin}/implicit/callback`,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    pkce: true,
    apiBaseURI: process.env.REACT_APP_API_URL,
    contactUsUrl: process.env.REACT_APP_CONTACT_US_URL,
    requestAccessUrl: process.env.REACT_APP_REQUEST_ACCESS_URL,
    logoutUrl: process.env.REACT_APP_LOGOUT_URL
};

export default config;
